import { MarketStructure } from "@/types/market-structure";
import React from "react";

const FeatureBox = ({ structure }: { structure: MarketStructure }) => {
  const { content } = structure;

  return (
    <div className="w-full">
      <div className="rounded-lg bg-white p-8 shadow-two duration-300 hover:shadow-one dark:bg-dark dark:shadow-three dark:hover:shadow-gray-dark lg:px-5 xl:px-8">
        <div className="space-y-8">
          {content.split('\n').map((paragraph, idx) => {
            if (paragraph.trim().startsWith('-')) {
              return null; // Skip bullet points here as we'll handle them separately
            }
            return (
              <p key={idx} className="text-center text-lg leading-relaxed text-body-color dark:text-white/70">
                {paragraph}
              </p>
            );
          })}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
            {content.split('\n').map((paragraph, idx) => {
              if (!paragraph.trim().startsWith('-')) {
                return null; // Skip non-bullet points
              }
              return (
                <div key={idx} className="transform transition-all duration-300 hover:scale-105">
                  <div className="relative overflow-hidden rounded-xl bg-gradient-to-b from-blue-500/10 to-transparent p-6 backdrop-blur-sm border border-blue-500/20 dark:from-blue-400/10 flex items-center justify-center min-h-[160px]">
                    <div className="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-blue-500 to-purple-500 opacity-75"></div>
                    <p className="text-base leading-relaxed text-body-color dark:text-white/70 text-center">
                      {paragraph.trim().substring(1).trim()}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureBox; 